import React, { Component } from "react";
import DOMPurify from "dompurify";

class VideoPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      isToggleOn: false,
      scroll: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
      scroll: !state.scroll,
    }));
    // console.log(this.state.scroll);

    document.body.style.overflow = this.state.scroll ? "auto" : "hidden";
  }

  render() {
    return (
      <div>
        <div className="play-button hover" onClick={this.handleClick}>
          {/* <img src={this.props.img} alt={`${this.props.name} img`} /> */}
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(`${this.props.img}`),
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#0096d7"
            // stroke="#ffff"
          >
            <path d="M3 22v-20l18 10-18 10z" />
          </svg>
        </div>
        <span>{this.props.name}</span>
        {this.state.isToggleOn && (
          <div className="video-popup-overlay">
            <div className="video-popup-content">
              <div className="video-info">
                <span className="big-text">{this.props.name}</span>
                <div onClick={this.handleClick} className="hover">
                  <div className="video-bar1" key="b1" />
                  <div className="video-bar2" key="b2" />
                </div>
              </div>

              <div className="video-frame">{this.props.iframe}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default VideoPopup;
